module.exports = __webpack_public_path__ + "assets/attention.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attention.svg
// module id = 1657
// module chunks = 7